<mat-card>
  <mat-card-content>
    <mat-card-title>
      Bilanci Gruppo Italiano Idraulica 

      <div fxFlex="70%;" fxFlex.xs="100%" align="right">
        <button mat-raised-button
                color="primary" (click)="btnIndietro()">
          Indietro
        </button>
      </div>

    </mat-card-title>
  </mat-card-content>
</mat-card>
<mat-card class="p-0 card">
  <mat-card-content class="card-body">
    <span style="color:red">{{sMessaggio}}</span>

    <table class="table">
      <tbody>
        <tr *ngFor="let row of lstElenco">
          <td (click)="btnVisibile(row)" style="cursor: pointer"> <mat-icon>picture_as_pdf</mat-icon> {{row.FileName}}</td>
        </tr>
      </tbody>
    </table>

  </mat-card-content>
</mat-card>

